import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import LeheApp from './lehe-app/LeheApp';

ReactDOM.render(
  <React.StrictMode>
    <LeheApp/>
  </React.StrictMode>,
  document.getElementById('root')
);

